import { __ } from "@wordpress/i18n";

/**
 * Limits enforced by the external ES quote/equity API.
 */
export const QUOTE_EQUITY_PROPERTY_VALUE_MIN = 1000;
export const QUOTE_EQUITY_PROPERTY_VALUE_MAX = 20000000;

/**
 * Limits loan terms in years.
 */
export const QUOTE_EQUITY_LOAN_TERMS_MIN = 1;
export const QUOTE_EQUITY_LOAN_TERMS_MAX = 40;

/**
 * Limits net income
 */
export const QUOTE_EQUITY_NET_INCOME_MIN = 0;
export const QUOTE_EQUITY_NET_INCOME_MAX = 20_000;

/**
 * Constants for labels
 */
export const QUOTE_EQUITY_LABELS = {
  title: __("Dados para a simulação", "df-simulators"),
  propertyValue: __("Preço do imóvel", "df-simulators"),
  region: __("Localização do imóvel", "df-simulators"),
  loanTermInYears: __("Prazo em anos", "df-simulators"),
  monthlyNetIncome: __("Rendimento Mensal Líquido", "df-simulators"),
  rateType: __("Tipo de taxa de juro", "df-simulators"),
  condition: __("Condição do imóvel", "df-simulators"),
};

/**
 * Options for select/radio fields
 */
export const QUOTE_EQUITY_OPTIONS = {
  rateType: [
    { value: "FIXED", label: __("Fixa", "df-simulators") },
    { value: "VARIABLE", label: __("Variável", "df-simulators") },
  ],
  condition: [
    { value: "NUEVA", label: __("Novo", "df-simulators") },
    { value: "USADA", label: __("Usado", "df-simulators") },
  ],
  region: [
    { value: "ANDALUCIA", label: __("Andalucía", "df-simulators") },
    { value: "ARAGON", label: __("Aragón", "df-simulators") },
    { value: "ASTURIAS", label: __("Asturias", "df-simulators") },
    { value: "CANARIAS", label: __("Canarias", "df-simulators") },
    { value: "CANTABRIA", label: __("Cantabria", "df-simulators") },
    {
      value: "CASTILLA_LA_MANCHA",
      label: __("Castilla-La Mancha", "df-simulators"),
    },
    { value: "CASTILLA_Y_LEON", label: __("Castilla y León", "df-simulators") },
    { value: "CATALUNA", label: __("Cataluña", "df-simulators") },
    { value: "CEUTA", label: __("Ceuta", "df-simulators") },
    {
      value: "COMUNITAT_VALENCIANA",
      label: __("Comunitat Valenciana", "df-simulators"),
    },
    { value: "EXTREMADURA", label: __("Extremadura", "df-simulators") },
    { value: "GALICIA", label: __("Galicia", "df-simulators") },
    { value: "ILLES_BALEARS", label: __("Illes Balears", "df-simulators") },
    { value: "LA_RIOJA", label: __("La Rioja", "df-simulators") },
    { value: "MADRID", label: __("Comunidad de Madrid", "df-simulators") },
    { value: "MELILLA", label: __("Melilla", "df-simulators") },
    { value: "MURCIA", label: __("Región de Murcia", "df-simulators") },
    {
      value: "NAVARRA",
      label: __("Comunidad Foral de Navarra", "df-simulators"),
    },
    { value: "PAIS_VASCO", label: __("País Vasco", "df-simulators") },
  ],
};
